import { createSlice } from "@reduxjs/toolkit"


interface IScansState {
  loading: "idle" | "pending" | "succeeded" | "failed"
  uploadSTL:{
    upper:File|null,
    lower:File|null,
  },
  uploadSTLForCreatingProcess:{
    upper:File|null,
    lower:File|null,
  }
}

const initialState: IScansState = {
  loading: "idle",
  uploadSTL:{
    upper:null,
    lower:null,
  },
  uploadSTLForCreatingProcess:{
    upper:null,
    lower:null,
  }
}

export const scansServiceSlice = createSlice({
  name: "scansService",
  initialState,
  reducers: {
    setUploadStls:(state,action)=>{
      state.uploadSTL = {...state.uploadSTL,...action.payload}
    },
    setUploadStlsForCreatingProcess:(state,action)=>{
      state.uploadSTLForCreatingProcess = {...state.uploadSTLForCreatingProcess,...action.payload}
    },
    clear:(state)=>{
      return {...initialState}
    }
  },
  extraReducers: (builder) => {
  },
})

export const {
  setUploadStls,
  setUploadStlsForCreatingProcess,
  clear:clearScansStatus
} = scansServiceSlice.actions
